import Enum from "../../../enums/Enum";

const DirectBillingPatientInformedStatusEnum = new Enum({
    APPOINTMENT_BOOKED:       {name: "Appointment Booked"},
    NO_ANSWER_WHATSAPP_SENT:  {name: "No Answer - Whatsapp Sent"},
    NO_ANSWER:                {name: "No Answer"},
    PATIENT_WILL_CALL_BACK:   {name: "Patient Will Call Back"},
    NO:                       {name: "No"},
});

export default DirectBillingPatientInformedStatusEnum;